import type { HubDaemon } from '@robovision/hub'
import { defineStore } from 'pinia'
import {
  reactive,
  readonly,
  toRefs,
} from 'vue'
import { hubApi } from '~services/api'


export const useDaemonsStore = defineStore('daemons', () => {
  const state = reactive({
    daemons: [] as HubDaemon[],
    loading: false as boolean,
  })

  const actions = {
    async loadDaemons (): Promise<void> {
      state.loading = true
      try {
        const { data: daemons } = await hubApi.daemons.listDaemons()
        state.daemons = daemons
      } finally {
        state.loading = false
      }
    },

    setState (params: Partial<typeof state>): void {
      Object.assign(state, params)
    },
  }

  return {
    ...toRefs(readonly(state)),
    ...actions,
  }
})
